import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { StickyBar } from "./components/StickyBar";
import Home from "./pages/Home";
import MenuPage from "./pages/MenuPage";
import Tentang from "./pages/Tentang";
import Lokasi from "./pages/Lokasi";
import Faq from "./pages/Faq";
import NotFound from "./pages/NotFound";

const PAGES = {
  "/": Home,
  "/menu/": MenuPage,
  "/tentang/": Tentang,
  "/lokasi/": Lokasi,
  "/faq/": Faq,
};

export default function App({ routePath }) {
  const raw =
    routePath ||
    (typeof window !== "undefined" ? window.location.pathname : "/");
  const path = raw === "/" || raw.endsWith("/") ? raw : `${raw}/`;
  const Page = PAGES[path] || NotFound;

  return (
    <div className="min-h-screen bg-coal font-body text-cream antialiased">
      <a
        href="#konten"
        data-testid="skip-to-content-link"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:bg-blood focus:px-4 focus:py-2 focus:font-mono focus:text-xs focus:uppercase focus:tracking-widest focus:text-cream"
      >
        Lewati ke konten
      </a>
      <Header currentPath={path} />
      <main id="konten">
        <Page />
      </main>
      <Footer />
      <StickyBar />
    </div>
  );
}
